import React from 'react';
import moment from "moment";
import Header from "../../components/header";
import Footer from "../../components/footer";
import $ from 'jquery';
import { connect } from "react-redux";
import { EditProfileService } from "../../services/common/action";
import DeleteModel from '../common/Model/deleteModel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {footer} from "../../components/footerSize";
import { onlyAlphabets, onlyNumbers} from "../common/keyValidation"

class ViewProfile extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            username: "",
            modalController: true,
            access_token: "",
            userId: "",
            userType: "",
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            dateOfBirth: "",
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            npi: "",
            registerStatus: "",
            fileName: "",
            officialEmail: "",
            officialPhone: "",
            officialFax: "",
            openPopUp: false,
            viewProfile: {
                username: "",
                access_token: "",
                userId: "",
                userType: "",
                firstName: "",
                lastName: "",
                email: "",
                mobile: "",
                dateOfBirth: "",
                address: "",
                address2: "",
                city: "",
                state: "",
                zip: "",
                npi: "",
                registerStatus: "",
                fileName: "",
                officialEmail: "",
                officialPhone: "",
                officialFax: "",
            },
            errors: {
                firstName: "",
                lastName: "",
                email: "",
                mobile: "",
                dateOfBirth: "",
                address: "",
                address2: "",
                city: "",
                state: "",
                zip: "",

            },
            firstNameValid: false,
            lastNameValid: false,
            emailValid: false,
            mobileValid: false,
            dateOfBirthValid: false,
            addressValid: false,
            address2Valid: false,
            cityValid: false,
            stateValid: false,
            zipValid: false,
            popupEdit: false,
            formValid: false,
            stateList: [],
            patientValid:false,
            adminValid:false,
            practiseValid : false,
            employeeValid:false,
            otherValid:false

        }
    }


    // modalController = () =>{
     //     this.setState({modalController:!this.state.modalController})
    // }
    handleChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;
     
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };
    handleDateOfBirthChange = (date) => {
      
        this.setState({
            dateOfBirth: date,
         },()=>{
            let value = this.state.dateOfBirth;
            if(value === null){
              this.setState({
                dateOfBirthValid : false
              })
            }else{
             this.setState({
               dateOfBirthValid : true
             })
           }
          });
    }

    validateField(fieldName, value) {
        const {
            errors,
            firstNameValid,
            lastNameValid,
            emailValid,
            mobileValid,
            dateOfBirthValid,
            addressValid,
            address2Valid,
            cityValid,
            stateValid,
            zipValid,


        } = this.state;
        let fieldValidationErrors = errors;
        let firstNamevalid = firstNameValid;
        let lastNamevalid = lastNameValid;
        let emailvalid = emailValid;
        let mobilevalid = mobileValid;
        let dateOfBirthvalid = dateOfBirthValid;
        let addressvalid = addressValid;
        let address2valid = address2Valid;
        let cityvalid = cityValid;
        let statevalid = stateValid;
        let zipvalid = zipValid;




        switch (fieldName) {
            case "firstName":
                firstNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors.firstName = firstNamevalid
                    ? ""
                    : "First Name should be 3 to 20 characters";
                break;
            case "lastName":
                lastNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors.lastName = lastNamevalid
                    ? ""
                    : "Last Name should be 3 to 20 characters";
                break;
            case "email":
                emailvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.email = emailvalid
                    ? ""
                    : " Please enter valid Email Address";
                break;
            case "mobile":
                mobilevalid = value.match(/^\d{10}$/);
                fieldValidationErrors.mobile = mobilevalid
                    ? ""
                    : " Please enter valid mobile number";
                break;
            case "dateOfBirth":
                dateOfBirthvalid = !(value.length < 5);
                fieldValidationErrors.dateOfBirth = dateOfBirthvalid
                    ? ""
                    : "Please enter your dateofbirth"
                break;
            case "address":
                addressvalid = !(value.length < 1);
                fieldValidationErrors.address = addressvalid
                    ? ""
                    : "Please enter the address";
                break;

            case "address2":
                address2valid = !(value.length < 1);
                fieldValidationErrors.address2 = address2valid
                    ? ""
                    : "Please enter the address2";
                break;

            case "city":
                cityvalid = !(value.length < 1);
                fieldValidationErrors.city = cityvalid
                    ? ""
                    : "Please enter the city";
                break;

            case "state":
                statevalid = !(value.length < 1);
                fieldValidationErrors.state = statevalid
                    ? ""
                    : "Please enter the state";
                break;

            case "zip":
                zipvalid = !(value.length < 1);
                fieldValidationErrors.zip = zipvalid
                    ? ""
                    : "Please enter the zip";
                break;

            default:
                break;
        }


        this.setState(
            {
                errors: fieldValidationErrors,
                firstNameValid: firstNamevalid,
                lastNameValid: lastNamevalid,
                emailValid: emailvalid,
                mobileValid: mobilevalid,
                dateOfBirthValid: dateOfBirthvalid,
                addressValid: addressvalid,
                address2Valid: address2valid,
                cityValid: cityvalid,
                stateValid: statevalid,
                zipValid: zipvalid,
            },
            this.validateForm
        );
    }

    validateForm() {
        const {
            firstNameValid,
            lastNameValid,
            emailValid,
            mobileValid,
            dateOfBirthValid,
            addressValid,
            cityValid,
            stateValid,
            zipValid,
        } = this.state;

 
      
        this.setState({
            patientValid:
                firstNameValid &&
                lastNameValid &&
                emailValid &&
                mobileValid &&
                dateOfBirthValid &&
                addressValid &&
                cityValid &&
                stateValid &&
                zipValid,

 

        });
    
    }


    propsTostates = (data) => {
   
        let modalData = this.state.viewProfile;
        modalData.access_token = this.props.loginDetails;
        modalData.username = data.username
        modalData.userId = data.userId;
        modalData.userType = data.userType;
        modalData.firstName = data.firstName;
        modalData.lastName = data.lastName;
        modalData.email = data.email;
        modalData.mobile = data.mobile;
        let date =  moment(data.dateOfBirth).format("MM-DD-YYYY"); 
        modalData.dateOfBirth = date
        modalData.address = data.address;
        modalData.address2 = data.address2;
        modalData.city = data.city;
        modalData.state = data.state;
        modalData.zip = data.zip;
      
        if(data.userType === "facility"){
            modalData.npi = data.npi;
            modalData.registerStatus = data.registrationStatus;
            modalData.fileName = data.fileName;
            modalData.officialEmail = data.officeEmail;
            modalData.officialPhone = data.officePhone;
            modalData.officialFax = data.faxNo;
        }


        this.setState({

            viewProfile: modalData,


        })
      
    }


    editprofileData = (e) => {
        e.preventDefault();
        const { viewProfile } = this.state
        let username = viewProfile.username;
        let access_token = viewProfile.access_token;
        let userId = viewProfile.userId;
        let userType = viewProfile.userType;
        let firstName = viewProfile.firstName;
        let lastName = viewProfile.lastName;
        let email = viewProfile.email;
        let mobile = viewProfile.mobile;
        let date = viewProfile.dateOfBirth;
        let dateOfBirth = moment(date).format('YYYY-MM-DD')
        let address = viewProfile.address;
        let address2 = viewProfile.address2
        let city = viewProfile.city;
        let state = viewProfile.state;
        let zip = viewProfile.zip;
        let npi = viewProfile.npi;
        let registerStatus = viewProfile.registerStatus;
        let fileName = viewProfile.fileName;
        let officialEmail = viewProfile.officialEmail;
        let officialPhone = viewProfile.officialPhone;
        let officialFax = viewProfile.officialFax;


        let errors = this.state.errors;
            errors.firstName = "";
            errors.lastName = "";
            errors.email = "";
            errors.mobile = "";
            errors.dateOfBirth = "";
            errors.address = "";
            errors.address2 = "";
            errors.city = "";
            errors.state = "";
            errors.zip = "";

     

     
        this.setState({
            username,
            access_token,
            userId,
            userType,
            firstName,
            lastName,
            email,
            mobile,
            dateOfBirth,
            address,
            address2,
            city,
            state,
            zip,
            npi,
            registerStatus,
            fileName,
            officialEmail,
            officialPhone,
            officialFax,
            firstNameValid : true,
            lastNameValid : true,
            emailValid : true,
            mobileValid : true,
            dateOfBirthValid : true,
            addressValid : true,
            address2Valid : true,
            cityValid : true,
            stateValid : true,
            zipValid : true,
            patientValid : true,
            adminValid : true,
            practiseValid : true,
            employeeValid : true,
            otherValid : true,
        }, () => {
            this.setState({
                popupEdit: true,
            });
        })
    }


    componentDidMount() {
        

         // onDocumentReady function bind
         $(document).ready(function () {
            footer("#content");
        });

        // onResize bind of the function
        $(window).resize(function () {
            footer("#content");
        });

     

        if (this.props.profileDetails) {
            let data = this.props.profileDetails.commonUser;
            let userType = this.props.profileDetails.commonUser.userType;
            this.setState({
                userType
            })
            this.propsTostates(data);
        }

        if (this.props.getByLocationDetails) {
            let data = this.props.getByLocationDetails.stateListObj;
            this.setState({
                stateList: data
            })
        }


    }



    confirmOkay = (e) => {
        e.preventDefault();


        const {
          
            access_token,
            userId,
            userType,
            firstName,
            lastName,
            email,
            mobile,
            dateOfBirth,
            address,
            address2,
            city,
            state,
            zip,
            npi,
            registerStatus,
            officialEmail,
            officialPhone,
            officialFax,
            fileName,

        } = this.state

        let date = moment(dateOfBirth).format('YYYY-MM-DD')



        let payLoad = {

            userId,
            userType,
            firstName,
            lastName,
            email,
            mobile,
            dateOfBirth:date,
            address,
            address2,
            city,
            state,
            zip,
        }

        let facilityPayload = {
            userId,
            userType,
            firstName,
            lastName,
            email,
            mobile,
            address,
            address2,
            city,
            state,
            zip,
            npi,
            registerStatus,
            officialEmail,
            officialPhone,
            officialFax,
            fileName,
        }




        let employeePayLoad = {
            id: userId,
            firstName,
            lastName,
            emailId: email,
            mobileNo: mobile,
            dateOfBirth:date,
            role: userType,

        }

     
        this.setState({
            openPopUp: false,

        })

        this.props.EditProfileService(access_token, payLoad, employeePayLoad,facilityPayload, );
    }
    openPop = () => {
        this.setState({
            openPopUp: true,

        })
    }
    closePop = () => {
        this.setState({
            openPopUp: false
        })
    }

    
navHome = (e) =>{
         e.preventDefault();

         switch (this.state.userType) {

            case "patient":
                this.props.history.push("/PatientHome");
                break;
            case "facility":
                this.props.history.push("/FacilityHome");
                break;
            case "admin":
                this.props.history.push("/AdminHome");
                break;
            case "employee":
                this.props.history.push("/EmployeHome");
                break;
            case "other":
                this.props.history.push("/PatientHome");
            break;
            default:
            break;
        }
    
}    

    componentWillReceiveProps = nextProps => {
        if (nextProps.editProfileStatus === true) {
            this.setState({ popupEdit: false });
            if (this.props.editProfileDetails) {
               // let data = this.props.editProfileDetails.commonUser;
            }
 
         }  
        if (this.props.profileDetails !== nextProps.profileDetails) {
            this.propsTostates(nextProps.profileDetails.commonUser)
        }

    };
 

    render() {
        const {
            userType,
            firstName,
            lastName,
            email,
            mobile,
            dateOfBirth,
            address,
            address2,
            city,
            state,
            zip,
            viewProfile,
            patientValid,
            dateOfBirthValid ,
            adminValid,
            practiseValid,
            employeeValid,
            otherValid,
            
            errors } = this.state
        
        return (
            <>

     <Header status ={"afterLogin"} routes={[{"name" : " View Profile", "route" : "/ViewProfile",}]}  />

                <div className="content">

                    <div className="contentSection" id="content">
                        <div className="container-fluid">
                            
                            <div className="bodyContent mtb50">
                                {/* <!-- Record Type --> */}
                                <div className="i-am-centered">
                                    <div className="row mt-2">
                                        <div className="user-image">
                                            <div className="col-lg-12 col-centered">
                                                <img alt="" src="images/login.jpg" />
                                                <div className="cross-mark">
                                               
                                                <a href="javascript:void(0)"  onClick={this.navHome}  ><i class="fa fa-times" aria-hidden="true"></i> </a>
                                        </div>
                                            </div>
                                            
                                        </div>
                                       
                                    </div>
                                    <div className="row mt-2">
                                        <div className="user-image">
                                            <div className="col-lg-12">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="add-width150">First Name</td>
                                                            <td className="value-col">{viewProfile.firstName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="add-width150">Last Name</td>
                                                            <td className="value-col">{viewProfile.lastName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="add-width150">Email</td>
                                                            <td className="value-col">{viewProfile.email}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="add-width150">Mobile</td>
                                                            <td className="value-col">{viewProfile.mobile}</td>
                                                        </tr>
                                                        {!(userType === "facility" || userType === "other") &&
                                                        <tr>
                                                            <td className="add-width150">Date of Birth</td>
                                                            <td className="value-col">{viewProfile.dateOfBirth}</td>
                                                        </tr>
                                                        }
                                                        {!(userType === "admin" || userType === "employee") &&
                                                            <>
                                                                <tr>
                                                                    <td className="add-width150">Address</td>
                                                                    <td className="width150 value-col">{viewProfile.address}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="add-width150">Address2</td>
                                                                    <td className="width150 value-col">{viewProfile.address2}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="add-width150">City</td>
                                                                    <td className="width150 value-col">{viewProfile.city}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="add-width150">State</td>
                                                                    <td className="width150 value-col">{viewProfile.state}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="add-width150">ZipCode</td>
                                                                    <td className="width150 value-col">{viewProfile.zip}</td>
                                                                </tr>
                                                            </>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                <div className="row mt-3 mb-2 text-center">
                                    <button type="button" className="btnDefault"
                                        onClick={this.editprofileData} >Edit</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />


                {/* <!-- Edit data --> */}
                {this.state.popupEdit &&
                    <div className="modal fade in" id="editdata" role="dialog">
                        <div className="modal-dialog" >
                            {/* <!-- Modal content--> */}
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={() => { this.setState({ popupEdit: false }) }}>&times;</button>
                                    <h4 className="modal-title header-title text-center">Edit User Details</h4>
                                </div>
                                <div className="modal-body" style={{ display: "block" }}>
                                    <div className="row">

                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label>First Name </label><sup>*</sup>
                                                <input type="text" name="firstName" value={firstName} onKeyPress={onlyAlphabets}
                                                    onChange={this.handleChange} placeholder="First Name" className="form-control" />
                                                <span style={{ color: "red" }}>{errors.firstName}</span>
                                            </div>

                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label> Last Name</label><sup>*</sup>
                                                <input type="text" name="lastName" value={lastName}
                                                    onChange={this.handleChange} placeholder="Last Name" className="form-control" />
                                                <span style={{ color: "red" }}>{errors.lastName}</span>
                                            </div>

                                        </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label> Email</label><sup>*</sup>
                                                <input type="text" name="email" value={email} disabled="true"
                                                    onChange={this.handleChange} placeholder="Email" className="form-control" />
                                                <span style={{ color: "red" }}>{errors.email}</span>
                                            </div>

                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group mobileinput">
                                                <label> Mobile Number</label><sup>*</sup>
                                                <div className="posrelative">
                                                    <input type="text" name="mobile" value={mobile}
                                                        onChange={this.handleChange} onKeyPress={onlyNumbers} placeholder="Mobile Number" maxLength="10" className="quantity form-control" />

                                                    <span style={{ color: "red" }}>{errors.mobile}</span>
                                                    <button type="button" className="mobliecountrycode1">+1</button>
                                                </div>
                                            </div>

                                        </div>
                                        </div>
                                        <div class="row">
                                        {!(userType === "facility" || userType === "other") &&
                                       
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <div className="form-group">
                                                <label> Date of Birth</label><sup>*</sup>
                                                <DatePicker selected={dateOfBirth} type="text" className="form-control" placeholderText="DateOfBirth *" name="dateOfBirth"
                                                    onChange={this.handleDateOfBirthChange}     peekNextMonth
                                                    maxDate={new Date()}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    autocomplete="false"
                                                 />
                                                <span style={{ color: "red" }}>{errors.dateOfBirth}</span>

                                            </div>
</div>
                                       
                                        }
                                        {!(userType === "admin" || userType === "employee") &&
                                            <>
                                            
                                          
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <div className="form-group">
                                                        <label>City</label><sup>*</sup>
                                                        <input type="text" name="city" value={city}
                                                            onChange={this.handleChange} placeholder="City" className="form-control" />
                                                        <span style={{ color: "red" }}>{errors.city}</span>

                                                    </div>

                                                </div>
                                                <div className="col-lg-12">
                                                <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <div className="form-group">
                                                        <label> Address1 </label><sup>*</sup>
                                                        <input type="text" name="address" value={address}
                                                            onChange={this.handleChange} placeholder="Address1" className="form-control" />
                                                        <span style={{ color: "red" }}>{errors.address}</span>

                                                    </div>

                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <div className="form-group">
                                                        <label> Address2</label><sup>*</sup>
                                                        <input type="text" name="address2" value={address2}
                                                            onChange={this.handleChange} placeholder="Address2" className="form-control" />
                                                        <span style={{ color: "red" }}>{errors.address2}</span>

                                                    </div>

                                                </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <div className="form-group">
                                                        <label>State</label><sup>*</sup>
                                                        <select className="form-control" id="sel1" name="state" value={state} onChange={this.handleChange}>
                                                            <option>State </option>
                                                            {this.state.stateList.length > 0 ?
                                                                this.state.stateList.map((state, id) => {
                                                                    return (
                                                                        <option key={id}>{state.name} </option>
                                                                    )
                                                                }) : ""
                                                            }
                                                        </select>
                                                        <span style={{ color: "red" }}>{errors.state}</span>

                                                    </div>


                                                </div>

                                             
                                                
                                               
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <div className="form-group">
                                                        <label>ZipCode</label><sup>*</sup>
                                                        <input type="text" name="zip" value={zip} maxLength="5"
                                                            onChange={this.handleChange} onKeyPress={onlyNumbers} placeholder="ZipCode" className="form-control" />
                                                        <span style={{ color: "red" }}>{errors.zip}</span>

                                                    </div>
                                                </div>
                                                </div>
                                                </div>
                                                
                                            </>
                                        }
                                    </div>
                                    </div>
                                    <div className="model-btn mb-3 text-center">
                                    <button type="button" disabled={!patientValid || !dateOfBirthValid} onClick={this.openPop} className="btnDefault"  >Update</button>
                                    <button type="button" className="btnDefault" onClick={() => { this.setState({ popupEdit: false }) }}>Cancel</button></div>
                                </div>
               
                            </div>
                            <DeleteModel header="Edit" text="Are you sure you want to edit?" page="editprofile" status={this.state.openPopUp} confirmOkay={this.confirmOkay} closePop={this.closePop} />

                        </div>

                    

                }

            </>
        )
    }
}

const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
    loginDetails: state.commonReducer.loginDetails,
    editProfileDetails: state.commonReducer.editProfileDetails,
    getByLocationDetails: state.patientReducer.getByLocationDetails,
    editProfileStatus: state.commonReducer.editProfileStatus,
    message: state.commonReducer.message

});
const mapDispatchToProps = dispatch => ({
    EditProfileService: (token, payLoad, employeePayLoad,facilityPayload, ) => dispatch(EditProfileService(token, payLoad, employeePayLoad,facilityPayload, ))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewProfile);

